import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function MessageTypeHeader() {
  const [t] = useTranslation("global");

  return (
    <div className="generalStyles__spaceBetween">
      <div className="generalStyles__mlFix mt-1">
        <span>{t("general.messageTypes")}</span>
      </div>
    </div>
  );
}

export default MessageTypeHeader;
